/* Слог — по языку, а не по буквам.
 *
 * Зачем файл существует. Колонка слогов в /song-generator считала ГЛАСНЫЕ
 * БУКВЫ одним правилом на все языки. Для русского это правило верное (слог =
 * гласная), для остальных — нет, и замер на живом корпусе (2191 песня, 83 894
 * спетые строки, 180 дней) показал цену:
 *
 *     язык   точно   ложных «не влезет»   пропущенных
 *     ru     97.7%   0.2%                 0.0%
 *     en     13.0%   10.1%                0.1%
 *     de     25.0%   4.5%                 —
 *     fr     26.7%   10.0%                —
 *     uk     12.9%   —                    16.4%     (в классе не было і ї є)
 *     ko      0.0%   —                    30.0%     (хангыль не считался вовсе)
 *
 * То есть у англоязычного автора каждая десятая исправная строка получала
 * красную пометку «не влезет в такт», а кореец не получал счёта вообще.
 *
 * Что здесь сделано и почему именно так. Правильный ответ даёт словарь
 * произношения (CMUdict 3.3 МБ, русский 13.8 МБ) — в браузер он не едет.
 * Поэтому замерены варианты, и выбран тот, что ближе всех к словарю при нулевой
 * цене (замер на том же корпусе, эталон — App\Services\Lyrics\Prosody).
 *
 * Правила — это школьные правила чтения (группы гласных, немая -e, -ed, -es) и
 * таблица исключений на частые слова, где правила ошибаются. Ни запроса к
 * серверу, ни загрузки словаря: счёт остаётся мгновенным при наборе.
 *
 * ⚠️ Язык строки определяется ЗДЕСЬ ЖЕ (`detect`), и мерить его по песням
 * нельзя: ярлык языка у них проставлен таким же алгоритмом, то есть эталон
 * приходится роднёй испытуемому — первый замер так и «доказал» ухудшение
 * французского, которое на деле было ошибкой эталона. Честный корпус — наши
 * файлы перевода, где язык задан папкой (замер 2026-09-12, отрывки по 3/5/8/15
 * слов): неверных ответов 0–3 %, остальное расхождение — честное «не знаю» на
 * слишком коротком куске, и там вызывающий берёт язык, выбранный человеком.
 *
 * Правда о слоге живёт в PHP (`App\Services\Lyrics\Prosody\*` +
 * `config/lyrics-prosody.php`) — здесь её БРАУЗЕРНАЯ копия, и согласие двух
 * копий держит сторож `tests/js/syllables-matches-prosody.test.mjs`.
 *
 * ⚠️ `null` значит «не знаю», и это не то же самое, что 0: для арабского слог
 * без огласовок неразрешим, и колонка обязана молчать, а не выдумывать число.
 */
(function (root) {
    'use strict';

    /* Гласные кириллицы — русские и украинские в одном классе: ы/э не бывают в
       украинском, і/ї/є — в русском, поэтому различать языки не требуется. */
    var CYR = /[аеёиоуыэюяіїє]/gi;
    var HANGUL = /[가-힣]/g;
    var ARABIC = /[ء-ي]/;

    /* Таблицы правил — копия config/lyrics-prosody.php. */
    var LANGS = {
        de: {
            vowels: 'aeiouäöüy',
            digraphs: ['ie', 'ei', 'ai', 'au', 'eu', 'äu', 'oi']
        },
        es: {
            vowels: 'aeiouáéíóúü',
            digraphs: ['ai', 'ei', 'oi', 'ui', 'au', 'eu', 'ou', 'iu',
                'ia', 'ie', 'io', 'ua', 'ue', 'uo', 'ay', 'ey', 'oy'],
            /* Синалефа: «viene el día» — vie-ne‿el-dí-a. Зеркало
               RuleProsody::synalepha(); знаки ударения — хиатус. */
            synalepha: true,
            stress: 'áéíóú',
            /* Немая u: que/qui/gue/gui — «aquí» = a-quí. Зеркало профиля `mute`. */
            mute: [[/qu(?=[eéií])/g, 'q'], [/gu(?=[eéií])/g, 'g']]
        },
        pt: {
            vowels: 'aeiouáéíóúâêôàãõ',
            digraphs: ['ai', 'ei', 'oi', 'ui', 'au', 'eu', 'ou', 'iu', 'ao',
                'ão', 'ãe', 'õe', 'ia', 'ie', 'io', 'ua', 'ue', 'uo'],
            synalepha: true,
            stress: 'áéíóúâêôãõ',
            mute: [[/qu(?=[eéêií])/g, 'q'], [/gu(?=[eéêií])/g, 'g']]
        },
        fr: {
            vowels: 'aeiouyàâäéèêëîïôöùûüœ',
            digraphs: ['eau', 'ai', 'ei', 'au', 'ou', 'oi', 'eu', 'œu', 'ui'],
            /* -e и -es немые одинаково: «étoiles» — 2 слога, «tu chantes» — 1. */
            silent: [/[^aeiouyàâäéèêëîïôöùûüœ]e$/, /[aeiouyéèê]e$/, /ent$/,
                /[^aeiouyàâäéèêëîïôöùûüœ]es$/, /[aeiouyéèê]es$/]
        },
        id: {
            vowels: 'aeiou',
            digraphs: ['ai', 'au', 'oi', 'ei']
        }
    };

    /* Слова, где школьные правила английского ошибаются. Взяты из пересечения
       SUBTLEX-US (частотность разговорной речи — ближайший к песне корпус) и
       CMUdict: слово попадает сюда, только если правило даёт не то число.
       Порог частоты выбран замером. Формат: слоги → список слов. */
    var EN_EXC = {
        1: ['are','one','use','clothes','ice','age','owe','ate','tongue','style','eve','kyle','league',
            'ace','drawer','ape','morgue','plague','belle','aisle','cheque','axe','vague','drawers','ale',
            'rogue','elle','tongues'],
        2: ['going','something','our','mr','doing','maybe','ok','being','trying','business','mrs','saying',
            'fire','hours','sometimes','hour','playing','evening','quiet','goodbye','tired','somewhere',
            'seeing','careful','tv','th','ls','colonel','lovely','lying','hundred','joey','dying','fired',
            'staying','client','crying','places','interest','leo','flying','trial','lately','somehow',
            'paying','beyond','phoebe','lonely','naked','several','player','science','brian','ours','liar',
            'pieces','someday','sometime','hired','buying','safety','someplace','awesome','mayor',
            'destroyed','charges','chocolate','statement','barely','changes','chances','ruin','surely',
            'wire','giant','faces','grateful','louis','likely','desperate','ruined','hire','jesse','create',
            'baseball','royal','basement','clients','forces','therefore','awfully','homework','useless',
            'settled','gimme','chloe','noel','cruel','wednesday','lifetime','enjoyed','daphne','fuel',
            'players','opera','merely','voices','diet','lion','movement','diane','louise','sacred','unique',
            'poem','pages','bottles','wicked','interests','sire','useful','chuckles','handled','stuart',
            'choices','catholic','tire','loyal','tables','beings','troubles','betrayed','shakespeare',
            'peaceful','laying','ages','safely','rhythm','homeless','privilege','candles','salesman',
            'praying','leon','nicely','warehouse','centre','cleveland','fires','tires','louie','farewell',
            'chaos','poet','closely','somewhat','hopeless','technique','fluid','noah','jr','dial','cd',
            'samples','judges','apples','prior','sources','mccoy','hawkeye','couples','circles','bp',
            'forehead','bracelet','joel','aspirin','pierre','wired','react','muscles','prices','alfred',
            'scrambled','lonesome','wires','household','rio','races','troubled','colleague','driveway',
            'rarely','andre','colleagues','riot','naive','hereby','lions','elsewhere','antique','noodles',
            'frederick','voyage','bubbles','dances','sour','dc','suing','crooked','lucille','fireworks',
            'foreman','mia','monte','mildred','sidewalk','spying','statements','hatred','delayed',
            'headaches','choir','buyer','needles','dante','rifles','battles','purely','cafe','traces','sr',
            'lifestyle','careless','strangled','bridges','homeland','princeton','cheyenne','poems',
            'movements','frances','maya','triumph','notebook','acres','ba','nipples','dryer','strangely',
            'pm','jose','werewolf','dj','ruins','handles','giants','posse','ankles','whistles','padre',
            'priceless','skiing','crippled','employed','lively','vs','charleston','stumbled','aces',
            'hometown','wages','trials','creates','bryan','berkeley','eagles','layer','judgement',
            'spaceship','pickles','wretched','liars','likewise','doubled','via','housewife','mystique',
            'rochelle','layout','techniques','cc','ph','knuckles','annoyed','triad','flyer','privileged',
            'comeback','giggles','nineteen','fluids','mayo','angles','braces','flour','tying','muffled',
            'toa','settles','marbles','beatles','turtles','hopeful','stables','meow','chocolates','fireman',
            'doubles','stages','homemade','sophomore','neon','edges','slayer','poets','frying','ninety',
            'singles','sideways','psyche','spaces','antiques','sidekick'],
        3: ['everything','idea','somebody','anyone','serious','interesting','interested','completely',
            'entire','realize','radio','area','especially','idiot','ourselves','everywhere','whoever',
            'video','easier','earlier','ideas','usual','realized','suicide','sexual','angeles','obvious',
            'carrying','subtitles','period','curious','basically','audience','hercules','piano','theater',
            'extremely','carefully','created','studio','violence','practically','maria','media','w',
            'champion','services','desire','studying','nuclear','messages','museum','alien','actual',
            'enjoying','violent','gambling','reaction','worrying','vietnam','marrying','miami','influence',
            'temperature','tokyo','poetry','engagement','gloria','empire','realise','happier','korea',
            'seattle','quietly','excitement','diego','graduate','scientist','precisely','employees',
            'hawaii','idiots','policeman','hopefully','loyalty','management','employee','entitled','visual',
            'theatre','serial','diana','annoying','everyday','orleans','creative','required','arguing',
            'require','announcement','warrior','excellency','korean','romeo','arrangements','heroin',
            'differently','scientists','hostages','aliens','requires','lesbian','previous','arrangement',
            'maniac','glorious','resources','alliance','recovery','diary','various','areas','ritual',
            'reunion','ohio','genuine','violet','manual','forgiveness','businessman','images','cynthia',
            'destroying','creating','inspired','recipe','karate','ruining','julian','casual','sylvia',
            'liable','mutual','harriet','annual','medium','ariel','soviet','guardian','beautifully',
            'miriam','enforcement','offices','warriors','miracles','happiest','carrier','cereal',
            'replacement','struggling','stadium','creation','articles','montgomery','furious','principles',
            'vehicles','juliet','stereo','vivian','housekeeper','prettiest','vegetable','gabriel','deline',
            'sophia','homecoming','audio','rodeo','joshua','hideous','employer','diapers','denial',
            'realised','gunfire','unlikely','loneliness','desires','rosemary','apache','involvement',
            'sincerely','vienna','elaborate','burial','violin','prettier','mafia','gideon','ungrateful',
            'heroic','acquired','gracias','balboa','radius','videos','triangle','betrayal','orgasm',
            'champions','settling','languages','giggling','alias','denying','tuition','easiest','reactor',
            'damages','usa','cardiac','massacre','fiance','royalty','naomi','marriages','packages',
            'savages','marian','improvement','privately','policemen','caviar','dolores','simpler','lionel',
            'mcdonald','amusement','devices','admired','unemployed','coyote','destroyer','applying','julio',
            'meteor','achievement','disabled','indian','barrier','beatrice','sentences','bandages',
            'courier','hawaiian','remotely','ratio','cheeseburger','sofia','pursuing','typewriter','adios',
            'babbling','circling','businesses','infrared','firearms','assembled','severely','particles',
            'fiancee','housekeeping','marianne','hustler','viola','advances','funniest','implying','fabian',
            'sarcasm','indians','austria','creator','atm','notices','partying','diagnosed','liaison',
            'valium','goliath','typically','lesbians','poetic'],
        4: ['everybody','actually','absolutely','appreciate','situation','definitely','seriously','usually',
            'experience','obviously','society','reality','unusual','circumstances','material','coincidence',
            'previously','mysterious','superior','appropriate','psychiatrist','scientific','immediate',
            'consequences','cooperate','specifically','priority','experienced','graduation','championship',
            'whatsoever','associate','spiritual','fortunately','sexually','radiation','mademoiselle',
            'graduated','violation','victoria','casualties','situations','european','memorial',
            'emotionally','coordinates','anxiety','negotiate','january','laboratory','scenario','antonio',
            'napoleon','positively','differences','reliable','desperately','hilarious','variety',
            'ultimately','evacuate','february','interior','olivia','videotape','vietnamese','canadian',
            'associates','biology','columbia','elementary','psychiatric','realistic','violated',
            'industrial','sanctuary','diagnosis','millennium','terrifying','materials','humiliate',
            'spontaneous','virtually','references','comedian','terrorism','continuing','idiotic',
            'caribbean','sacrifices','journalism','unreasonable','mechanism','notorious','intuition',
            'initiate','karaoke','relatively','priorities','diabetes','santiago','condolences',
            'appreciates','appearances','inferior','criticism','bacteria','asap','satisfactory','suicidal',
            'librarian','advantages','superiors','leonardo','aquarium','casualty','hungarian'],
        5: ['unfortunately','eventually','individual','philadelphia','curiosity','association',
            'cooperation','approximately','experiences','humiliated','inappropriate','deliberately',
            'humiliating','biological','appreciated','cafeteria','appreciation','homosexual','humiliation',
            'intellectual','enthusiasm','louisiana','evaluation','individuals','experiencing',
            'automatically','vegetarian','associated','overreacting','antibiotics','negotiations',
            'evacuation','radioactive','liability','sexuality','negotiating','enthusiastic'],
        6: ['extraordinary']
    };

    var EN_EXC_MAP = (function () {
        var m = Object.create(null), n, i, list;
        for (n in EN_EXC) {
            list = EN_EXC[n];
            for (i = 0; i < list.length; i++) { m[list[i]] = +n; }
        }
        return m;
    })();

    function stripTags(line) {
        return String(line == null ? '' : line).replace(/\[[^\]]*\]/g, ' ');
    }

    /* ── Английский ──────────────────────────────────────────────────────── */

    function enWord(w) {
        w = w.toLowerCase().replace(/[^a-z]/g, '');
        if (!w) { return 0; }
        if (EN_EXC_MAP[w] !== undefined) { return EN_EXC_MAP[w]; }
        var groups = w.match(/[aeiouy]+/g);
        if (!groups) { return 1; }
        var n = groups.length;
        /* немая -e: «make», «love» — но не «the», «be», и не слоговая -le */
        if (/[^aeiou]e$/.test(w) && !/[^aeiou]le$/.test(w) && w.length > 3) { n--; }
        /* -ed после не-t/d слога не даёт: «walked», но «wanted» даёт */
        if (/[^aeioutd]ed$/.test(w)) { n--; }
        /* -es после не-шипящего не даёт: «makes», но «boxes» даёт */
        if (/[^sxzh]es$/.test(w) && !/[aeiou]es$/.test(w)) { n--; }
        return Math.max(1, n);
    }

    function enLine(line) {
        var words = stripTags(line).match(/[a-z']+/gi), sum = 0, i;
        if (!words) { return null; }
        for (i = 0; i < words.length; i++) { sum += enWord(words[i]); }
        return sum > 0 ? sum : null;
    }

    /* ── Языки, где слог виден из орфографии ─────────────────────────────── */

    function ruleWord(w, p) {
        var i = 0, n = 0, two, three, ch, len;
        if (p.mute) { for (i = 0; i < p.mute.length; i++) { w = w.replace(p.mute[i][0], p.mute[i][1]); } i = 0; }
        len = w.length;
        while (i < len) {
            three = w.substr(i, 3);
            if (p.digraphs.indexOf(three) !== -1) { n++; i += 3; continue; }
            two = w.substr(i, 2);
            if (p.digraphs.indexOf(two) !== -1) { n++; i += 2; continue; }
            ch = w.charAt(i);
            if (p.vowels.indexOf(ch) !== -1) { n++; }
            i++;
        }
        /* Немые концовки (французская -e, глагольное -ent) слога не дают. */
        if (p.silent) {
            for (i = 0; i < p.silent.length; i++) {
                if (n > 1 && p.silent[i].test(w)) { n--; }
            }
        }
        return Math.max(1, n);
    }

    /* Стык двух слов — один слог? Зеркало RuleProsody::synalepha() (PHP):
       гласный + гласный (или немая h + гласный) сливаются, союз «y» — гласный
       звук без буквы, знак ударения на стыке — хиатус. Конечная «y» слова
       («hoy») стыка не образует. */
    function synalepha(prev, next, p) {
        if (!p.synalepha) { return false; }
        var last = prev.charAt(prev.length - 1), first = next.charAt(0);
        var lastV = prev === 'y' || p.vowels.indexOf(last) !== -1;
        if (first === 'h') { first = next.charAt(1); }
        var firstV = next === 'y' || (!!first && p.vowels.indexOf(first) !== -1);
        if (!lastV || !firstV) { return false; }
        var marks = p.stress || '';
        if (marks && (marks.indexOf(last) !== -1 || marks.indexOf(first) !== -1)) { return false; }
        return true;
    }

    function ruleLine(line, p) {
        var words = stripTags(line).match(/[^\s\d.,!?;:()"«»—–…]+/g) || [], sum = 0, i, w, prev = null;
        for (i = 0; i < words.length; i++) {
            w = words[i].toLowerCase().replace(/^['’-]+|['’-]+$/g, '');
            if (!w) { continue; }
            if (prev !== null && synalepha(prev, w, p)) { sum--; }
            sum += ruleWord(w, p);
            prev = w;
        }
        return prev === null ? null : Math.max(1, sum);
    }

    /* ── Определение языка текста ────────────────────────────────────────── */

    /* Служебные и песенные слова — по ним узнаётся язык. Список намеренно
       длиннее школьного минимума: во французском корпусе диакритику несут 12
       строк из 120 (её просто не набирают), и различать французский от
       испанского приходится СЛОВАМИ, а не значками — на коротком отрывке без
       этого он опознавался в 17 % случаев. Слова выбраны частотные И
       различающие: общие для романских («la», «de», «no») стоят у всех и
       поэтому никому не помогают. */
    var STOP = {
        en: 'the a an and or but i you we they it is are was be to of in on at for with my your me not no all so '
          + 'have got dont im its just like know love night time away again heart never always feel cant will',
        de: 'der die das ein eine und oder aber ich du wir sie es ist sind war nicht kein zu von in auf mit mein dein noch nur '
          + 'wie was wenn immer nie mehr schon dich mich liebe nacht herz zeit wieder ganz sehr doch dann hier',
        es: 'el la los las un una y o pero yo tu ella es son no de en con mi me te se por para que como '
          + 'muy bien siempre nunca amor vida corazon quiero tengo estoy mas solo cuando donde porque nada todo ahora aqui',
        pt: 'o a os as um uma e ou mas eu tu ele ela são não de em com meu me te se por para que como '
          + 'você muito sempre nunca amor vida coração quero tenho estou mais só quando onde porque nada tudo agora aqui',
        fr: 'le la les un une et ou mais je tu il elle est sont ne pas de en avec mon me te se pour que comme '
          + 'toujours amour nuit coeur cœur moi toi vous nous sans plus rien tout jamais encore quand dans alors '
          + 'suis fait dit voir aime chaque des du au aux ça cette ces être faire veux peux vais',
        id: 'yang dan atau tapi aku kamu dia kita kami ini itu tidak bukan di ke dari dengan untuk ada akan sudah '
          + 'lagi masih cinta hati malam waktu selalu pernah hanya karena sangat bisa mau semua saja',
        /* Турецкий — язык пения (config/ai-music.vocal_languages), которого
           здесь не было до 2026-09-23: на турецком тексте определитель
           отвечал null, и кнопка переложения не могла назвать цель. Слова
           без пересечений с романскими наборами: «de/da/o/ne/mi» намеренно
           не взяты — они в чужих списках и дали бы только шум. */
        tr: 'bir ve bu ben sen biz siz ile için ama çok gibi var yok kadar her hiç seni beni sana bana benim senin '
          + 'değil olsun artık yine hep asla şimdi sonra zaman hayat aşk kalbim gece gel git seviyorum yalnız bile daha '
          + 'çünkü nasıl neden şey kim böyle şu onu bunu kendi bütün hiçbir seninle benimle gözlerin ellerin'
    };
    var STOP_SET = (function () {
        var out = {}, k;
        for (k in STOP) { out[k] = new Set(STOP[k].split(' ')); }
        return out;
    })();

    /* Буквы, которые есть ТОЛЬКО у одного из наших латинских языков. Служебные
       слова у романских пересекаются («a», «no», «de»), и на двух строках счёт
       совпадений даёт ничью — а ничья, разрешённая порядком перебора, это
       молчаливая ошибка: португальский набросок считался английским (поймано
       фикстурой 2026-09-12). Диакритика разрешает такие ничьи по существу. */
    var MARK = { de: /[äöüß]/, es: /[ñ¿¡]/, pt: /[ãõ]/, fr: /[œùëçâ]/, id: null, tr: /[ığşİ]/ };

    function detect(text) {
        var t = String(text == null ? '' : text).toLowerCase();
        /* Порог письменности низкий намеренно: строка «사랑이 밤을» — это пять
           знаков хангыля, и прежнее «больше пяти» отправляло её к служебным
           словам латиницы, которая отвечала чем попало (замер по отрезкам: на
           ОДНОЙ строке корейский определялся неверно в 60 % случаев). Две буквы
           чужого письма случайностью не бывают. */
        if ((t.match(HANGUL) || []).length >= 2) { return 'ko'; }
        if ((t.match(/[ء-ي]/g) || []).length >= 2) { return 'ar'; }
        /* Украинский или русский — общий определитель сайта (timbrica-core,
           root.__cyrillicLang), а не «есть ли і»: по одной букве русская строка
           со словом «Київ» считалась по украинским правилам. Кириллица другого
           языка — по русским, как прежде у татарского и башкирского. */
        if ((t.match(/[а-яё]/g) || []).length >= 2) {
            var cy = typeof root.__cyrillicLang === 'function' ? root.__cyrillicLang(String(text)) : 'ru';
            return cy === 'uk' ? 'uk' : 'ru';
        }
        var words = t.match(/[^\s\d.,!?;:()"«»—–…]+/g) || [];
        if (words.length < 3) { return null; }
        /* Короткому тексту нужна БОЛЬШАЯ доля попаданий: на четырёх словах одно
           случайное совпадение даёт те же 25 %, что у настоящего языка. Порог
           выбран замером по отрезкам корпуса (см. шапку). */
        var need = words.length < 8 ? 0.2 : 0.05;
        var best = null, bestScore = 0, second = 0, lang, hits, score, i;
        for (lang in STOP_SET) {
            hits = 0;
            for (i = 0; i < words.length; i++) {
                if (STOP_SET[lang].has(words[i])) { hits++; }
            }
            score = hits / words.length + (MARK[lang] && MARK[lang].test(t) ? 0.05 : 0);
            if (score > bestScore) { second = bestScore; bestScore = score; best = lang; }
            else if (score > second) { second = score; }
        }
        /* Ничья и почти-ничья — честный «не знаю»: вызывающий возьмёт язык,
           выбранный в туле, а это ответ пользователя, и он точнее догадки.
           На коротком отрывке запас обязателен: романские делят «la», «de»,
           «no», и лидер по одному случайному совпадению — это не язык. */
        var margin = words.length < 8 ? 0.05 : 0;

        return (bestScore >= need && bestScore > second + margin) ? best : null;
    }

    /* ── Письменность текста ─────────────────────────────────────────────── */

    /* Чем НАБРАН текст — 'cyrl' | 'latn' | 'arab' | 'hang' | null. Те же коды и
       тот же порог (0.6 букв одной письменности, минимум 20 букв), что у
       `App\Support\LanguageNames::textScript()` на сервере: страница
       предлагает переложение по тому же правилу, по которому сервер задаёт
       вопрос «слова не на языке пения» перед списанием, и оба обязаны
       отвечать одинаково. Маркеры секций ([Verse]) вычёркиваются — они
       латинские у всех. Языки, которых `detect` не знает (турецкий до 23.09,
       итальянский), письменность имеют всё равно — по ней и судим. */
    var SCRIPTS = {
        cyrl: /[\u0400-\u04FF]/g,
        latn: /[A-Za-z\u00C0-\u024F]/g,
        arab: /[\u0600-\u06FF]/g,
        hang: /[\uAC00-\uD7AF\u1100-\u11FF\u3130-\u318F]/g
    };
    function script(text) {
        var t = String(text == null ? '' : text).replace(/\[[^\]]*\]/g, ' ');
        var total = 0, best = null, bestN = 0, k, n;
        for (k in SCRIPTS) {
            n = (t.match(SCRIPTS[k]) || []).length;
            total += n;
            if (n > bestN) { bestN = n; best = k; }
        }
        if (total < 20) { return null; }
        return bestN / total >= 0.6 ? best : null;
    }

    /* ── Публичная дверь ─────────────────────────────────────────────────── */

    /**
     * Слогов в строке, или null — «не знаю» (арабский без огласовок, пустая
     * строка, язык не назван и не угадан).
     */
    function count(line, lang) {
        var clean = stripTags(line).replace(/[̀́]/g, '');
        if (!clean.trim()) { return null; }

        /* ⚠️ Решает ПИСЬМЕННОСТЬ СТРОКИ, а не объявленный язык, и это не
           придирка: на русской странице английский набросок из четырёх слов
           определителю не по зубам (он молчит короче восьми слов), запасным
           языком приходит `ru`, и счёт кириллических гласных даёт ноль —
           колонка просто пропадает. Поймано живым браузером 2026-09-12; ни
           один замер на корпусе этого не видел, потому что там язык всегда был
           известен. */
        var hangul = (clean.match(HANGUL) || []).length;
        if (hangul) { return hangul; }
        var cyrLetters = (clean.match(/[а-яёіїєґ]/gi) || []).length;
        var latLetters = (clean.match(/[a-zà-öø-ÿœ]/gi) || []).length;
        if (cyrLetters > latLetters) { return (clean.match(CYR) || []).length || null; }
        if (!latLetters) { return null; }   // арабица, иероглифы, одни цифры — не судим

        var p = LANGS[lang];
        if (p) { return ruleLine(clean, p); }

        /* Латиница при языке без своей таблицы (en, а также ru/uk/ko/ar, когда
           строка всё же набрана латиницей) — английские правила: группы
           гласных и немая -e ближе к любому латинскому письму, чем счёт букв. */
        return enLine(clean);
    }

    root.__syllables = {
        count: count,
        detect: detect,
        script: script,
        langs: Object.keys(LANGS).concat(['ru', 'uk', 'en', 'ko', 'ar'])
    };

    if (typeof module === 'object' && module.exports) { module.exports = root.__syllables; }
})(typeof globalThis !== 'undefined' ? globalThis : this);
